export default "__VITE_ASSET__b490c3cf__"